import { get, merge, set, isNil, find, includes, map } from 'lodash';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { validateFormField } from '../../../../../../modelValidator';
import * as companyApi from '../../../../../../redux/actionCreators/async/companies';
import * as syncActionCreators from '../../../../../../redux/actionCreators/sync';
import * as ui from '../../../../../../redux/actionCreators/sync/ui';
import TextField from '../../../../../../common/components/c_TextField';
import TextArea from '../../../../../../common/components/c_TextArea';
import {findContact} from '../../../../../../redux/helpers/contacts';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import CheckListTextField from '../../../../../../common/components/CheckListTextField';
import DropdownChecklist from '../../../../../../common/components/DropdownChecklist';
import {parentChildList} from '../../../../../../lib/parentChildList';
import {activeSegmentTypes} from '../../../../../../lib/industrySegments';

const message = 'This field is required.';
const required = { message };

@connect((store, props) => {
  let contact = null;
  if (props.params.contactId) {
    const contactId = parseInt(props.params.contactId, 10);
    const isContactWorksheet = /\/admin\/contacts\/\d+\/details\/company/g;

    if(isContactWorksheet.test(props.location.pathname)) {
      contact = get(store.admin, 'contactInContactWorksheet', {});
    }else{
      contact = findContact({profile: {id: contactId}}, get(store.admin.contacts, 'items', []));
    }

  }

  return {
    companyId : contact ? contact.company.id : parseInt(props.params.companyId, 10) || 0,
    company   : contact ? contact.company : store.admin.company,
    staticData: store.staticData,
    labels    : get(store, 'labels.ProfilePanel', {}),
  };
})
export default class ProfilePanel extends Component {
  static propTypes = {
    dispatch  : PropTypes.func.isRequired,
    company   : PropTypes.object.isRequired,
    params    : PropTypes.object.isRequired,
    contact   : PropTypes.object
  }

  constructor(props, context) {
    super(props, context);
// TODO: This validation must be kept in sync (for matching values) with shared/models/company.js!
    this.state = {
      segmentTypes : {
        value : this.props.company.segmentTypes || [],
        required
      },
      segmentOther : {
        value : this.props.company.segmentOther || [],
      },
      industryTypes : {
        value : this.props.company.industryTypes || [],
        required
      },
      industryOther : {
        value : this.props.company.industryOther || [],
      },
      description : {
        value : this.props.company.description || '',
        required
      },
      numberOfOffices : {
        value : this.props.company.numberOfOffices || 0,
        required
      },
      numberOfEmployees : {
        value : this.props.company.numberOfEmployees || 0,
        required
      },
      parentCompany : {
        value : this.props.company.parentCompany || '',
        required
      },
      children : {
        value : this.props.company.children || '',
        required
      },
      tradeAssociations : {
        value : this.props.company.tradeAssociations || [],
      },
      associationOther : {
        value : this.props.company.associationOther || [],
      },
      affiliationTypes : {
        value : this.props.company.affiliationTypes || [],
      },
      affiliationOther : {
        value : this.props.company.affiliationOther || [],
      },
      iiabaState : {
        value : this.props.company.iiabaState || ''
      },
      salesPartner : {
        value : this.props.company.salesPartner || ''
      },
      placementFee : {
        value : this.props.company.placementFee,
        custom: {
          func: val => !this.props.labels.showPlacementFee || !isNil(val), // regular required property doesn't accept 0 as required value.
          message: 'This field is required.'
        }
      },
      placementFeeOther : {
        value : this.props.company.placementFeeOther || '',
        required
      },
      commission: {
        value : this.props.company.commission
      },
      tradeAssociationsOther : {
        value : this.props.company.tradeAssociationsOther || '',
        required
      },
      showErrorMessage: false,
    };

    this.parentChildHandlers = parentChildList();

  }

  getPlacementFee = (salesPartner) => {

    const cState = find(this.props.staticData.salesPartners, (partner) => partner.id === salesPartner);
    return get(cState, 'fee');

  }

  getCommission = (salesPartner) => {

    const cState = find(this.props.staticData.salesPartners, (partner) => partner.id === salesPartner);
    return get(cState, 'commission');

  }

  handleChange(field) {
    return (event, value) => {
     this.handleUpdateField && this.handleUpdateField(event, field, value);

      if(field === 'salesPartner') {
        const commission = {
          value: this.getCommission(value),
        };

        const placementFee = {
          value: this.getPlacementFee(value),
          custom: this.state.placementFee.custom
        };

        this.setState({placementFee, commission});
      }
    };
  }

  handleUpdateField(event, field, value) {
    if (field==='segmentTypes' && isNil(value)) return; // WPS-43 - do not clear segment types when parent changes
    value = isNil(value) ? (isNil(event) ? null : get(event, 'target.value', null)) : value;
    const newState = set(merge({}, this.state), `${field}.value`, value);
    set(newState, `${field}.errors`, validateFormField(field, newState));
    const errorText = get(newState, `${field}.errors[0]`, null);
    this.setState(merge(newState, { showErrorMessage: !!errorText }));
    if (errorText) {
      // warn the user, don't just ignore the message
      this.props.dispatch(ui.warningToast(`Error ${errorText} updating field: ${field}`));
    }
    return !!errorText;
  }

  currencyToNumber (currency) {
    const currencyString = String(currency);
    return Number(currencyString.replace(/[^0-9\.]+/g, ''));
  }

  handleSubmitForm(field) {
    return (event, value) => {
      const hasError = (this.handleUpdateField && this.handleUpdateField(event, field, value));

      // if there's an error updating the field, don't submit form;
      if (hasError) return;

      const companyUpdate = {
        id: this.props.companyId
      };

      // set 'null' value to empty array for trade assoc. and affiliationTypes
      // update company repo needs an empty array to set fields to none
      if (includes(['tradeAssociations', 'affiliationTypes'], field) && !value) {
        value = [];
      }

      companyUpdate[field]=value;

      if(field === 'salesPartner') {
        companyUpdate.placementFee =  this.getPlacementFee(value);
        companyUpdate.commission = this.getCommission(value);
      }

      if(field === 'placementFee') {
        companyUpdate.placementFee =  value;

          if(companyUpdate.placementFee < this.props.company.placementFee) {
            companyUpdate.reducedFee = true;
          }else{
            companyUpdate.reducedFee = false;
          }
      }

      if (field === 'iiabaState') {
        const iiabaState = find(this.props.staticData.iiabaStates, {id: value}) || {};
        const salesPartner = find(this.props.staticData.salesPartners, {commissionName: iiabaState.commissionName});
        if (salesPartner) {
          companyUpdate.salesPartner = salesPartner.id;
          const salesPartnerUpdate = {value: companyUpdate.salesPartner};
          const placementFee = {value: salesPartner.fee, custom: this.state.placementFee.custom};
          const commission = {value: salesPartner.commission};
          companyUpdate.placementFee = placementFee.value;
          companyUpdate.commission = commission.value;
          this.setState({salesPartner: salesPartnerUpdate, placementFee, commission});
        } else {
          const iiabaState = find(this.props.staticData.iiabaStates, {id: value});
          if (iiabaState) {
            const placementFee = {value: iiabaState.fee, custom: this.state.placementFee.custom};
            const commission = {value: iiabaState.commission};
            const salesPartnerUpdate = {value: null};
            this.setState({placementFee, commission, salesPartner: salesPartnerUpdate});
            companyUpdate.placementFee = placementFee.value;
            companyUpdate.commission = commission.value;
            companyUpdate.salesPartner = salesPartnerUpdate.value;
          } else {
            const defaultPlacementFee = this.props.staticData.account.defaultSetupFee;
            const placementFee = {value: defaultPlacementFee};
            const commission = {value: null};
            const salesPartnerUpdate = {value: null};
            this.setState({placementFee, commission, salesPartner: salesPartnerUpdate});
            companyUpdate.placementFee = defaultPlacementFee;
            companyUpdate.commission = null;
            companyUpdate.salesPartner = null;
          }
        }
      }

      this.props.dispatch(companyApi.updateCompanyById(companyUpdate, (err, data) => {
          if (err) {
            return console.error(err);
          }
          const company = get(data, 'body.data.items[0]');
          const groups = get(this.props, 'staticData.companyStatus', []);

          if(field === 'placementFee' || field === 'salesPartner') {
            const placementFee = {
              value: companyUpdate.placementFee,
              custom: this.state.placementFee.custom
            };
            this.setState({placementFee});
          }

          if(field === 'salesPartner') {
            const commission = {
              value: companyUpdate.commission,
            };
            this.setState({commission});
          }
          this.props.dispatch(syncActionCreators.getCompanyInfo({company, groups}));
          this.props.dispatch(ui.showSnackBar());
      }));
    };

  }

  iiabaStateMenuItems = () => {
    return [
      { id: null, name: 'None' },
      ...(get(this.props, 'staticData.iiabaStates', []))
    ];
  }

  salesPartnerMenuItems = () => {
    return [
      { id: null, name: 'None' },
      ...(get(this.props, 'staticData.salesPartners', []))
    ];
  }

  handleCheckListTextFieldUI = (name, title, menuItems) => {

      return {
        dataId: name,
        defaultValue: get(this.state, `${name}.value`),
        floatingLabelText: title,
        onChange: this.handleChange(name),
        onBlur: this.handleSubmitForm(name),
        className: 'row',
        checkListContainerClassName: 'col fixed-width-field',
        textfieldContainerClassName: 'col grow-3',
        showLabel: true,
        menuItems
      };
  }

  handleTextAreaUI = (name, title) => {
      return {
          value: get(this.state, `${name}.value`),
          onChange: this.handleChange(name),
          onBlur: this.handleSubmitForm(name),
          descriptionHead: title
      };
  }

  handleTextFieldUI = (name, title) => {
      return {
          value: get(this.state, `${name}.value`),
          floatingLabelText: title,
          onChange: this.handleChange(name),
          onBlur: this.handleSubmitForm(name),
          floatingLabelFixed: true,
          'data-id': name
      };
  }

  handleDropdownUI = (name, title) => {
      return {
        'data-id': name,
         value: get(this.state, `${name}.value`),
         floatingLabelText: title,
         onChange: this.handleChange(name),
         onBlur: this.handleSubmitForm(name),
      };
  }

  handlePlacementFeeDropdownUI = () => {

    const menuItems = map(this.props.staticData.setupFees,
      item => {
        return {
          primaryText: item.name === '$0' ? 'Waived' : item.name,
          value: this.currencyToNumber(item.name)
        };
      });

    return {
      'data-id': 'placementFee',
       value: get(this.state, 'placementFee.value'),
       floatingLabelText: 'One Time Setup Fee',
       onChange: this.handleChange('placementFee'),
       onBlur: this.handleSubmitForm('placementFee'),
       menuItems
    };

  }

  render() {

    const segmentTypes = get(this.props.staticData, 'segmentTypes');
    const otherSegmentType = get(find(segmentTypes, {name: 'Other'}), 'id');
    const industryTypes = get(this.props.staticData, 'industryTypesList');
    const otherIndustryType = get(find(industryTypes, {name: 'Other'}), 'id');
    const allSegments = activeSegmentTypes(segmentTypes, industryTypes, get(this.state, 'industryTypes.value'), get(this.state, 'segmentTypes.value'));

    const {parent: industryTypeProps, child: segmentTypeProps} = this.parentChildHandlers({
      parentProps: this.handleCheckListTextFieldUI('industryTypes', this.props.labels.industry, industryTypes),
      childProps: this.handleCheckListTextFieldUI('segmentTypes', 'Industry Segment',  segmentTypes),
    });

    const tradeAssociations = get(this.props.staticData, 'tradeAssociations');
    const otherTradeAssociations = get(find(tradeAssociations, {name: 'Other'}), 'id');

    return (
      <div className='company-profile-panel'>
        <div className='grid company-information'>

         <div className='row'>
           <div className='col grow-4'>
            <CheckListTextField
              {...industryTypeProps}
              errorText={get(this.state, 'industryTypes.errors') && get(this.state, 'industryTypes.errors[0]')}
              />
            </div>
              {
                includes(this.state.industryTypes.value, otherIndustryType) &&
                  <div className='col'>
                    <TextField {...this.handleTextFieldUI('industryOther', 'Other')}  />
                  </div>
              }
            </div>

            <div className='row'>
              <div className='col grow-4'>
                <DropdownChecklist
                  data-id={'segmentTypes'}
                  textLabel={get(this.props.labels, 'segmentTypes')}
                  defaultLabel={'Industry Segment'}
                  menuItems={allSegments}
                  value={get(this.state, 'segmentTypes.value')}
                  groupBy={'parentName'}
                  errorText={get(this.state, 'segmentTypes.errors[0]') || 'This field is required'}
                  dirty={!!get(this.state, 'industryTypes.value', false)}
                  onChange={this.handleSubmitForm('segmentTypes')}
                  required
                />
              </div>
                {
                  includes(this.state.segmentTypes.value, otherSegmentType) &&
                    <div className='col'>
                       <TextField {...this.handleTextFieldUI('segmentOther', 'Other')}  />
                    </div>
                }
            </div>
        </div>

        <div className='grid company-description'>
            <div className='row'>
              <div className='col'>
                <TextArea
                  {...this.handleTextAreaUI('description', 'Company Description')}
                  data-id={'company-description'}
                />
              </div>
              <div className='col col-offices-employees'>
                  <div className='row'>
                      <div className='col'>
                          <TextField {...this.handleTextFieldUI('numberOfOffices', '# of Offices')}  />
                      </div>
                      <div className='col'>
                         <TextField {...this.handleTextFieldUI('numberOfEmployees', '# of Employees')}  />
                      </div>
                  </div>
              </div>
            </div>
         </div>

        <div className='grid company-relationships'>
            <div className='row'>
                <div className='col fixed-width-field'>
                  <TextField {...this.handleTextFieldUI('parentCompany', 'Parent')}  />
                </div>
                <div className='col'>
                  <TextField {...this.handleTextFieldUI('children', 'Child')}  />
                </div>
            </div>

            {
              this.props.labels.showTradeAssociation
              &&
              <div className='row'>
                <div className='col grow-4'>
                  <CheckListTextField
                    {...this.handleCheckListTextFieldUI('tradeAssociations', 'National Trade Associations')}
                    menuItems={map(this.props.staticData.tradeAssociations, ({id, crmName}) => ({id, name: crmName}))}
                  />
                </div>

              {
                includes(this.state.tradeAssociations.value, otherTradeAssociations)
                &&
                <div className='col'>
                  <TextField {...this.handleTextFieldUI('associationOther', 'Other')}  />
                </div>
              }
              </div>
            }

             <div className='row'>
              <div className='col grow-4'>

                {
                  this.props.labels.showAffiliations &&

                  <CheckListTextField
                    {...this.handleCheckListTextFieldUI('affiliationTypes', 'Affiliations')}
                    menuItems={this.props.staticData.affiliationTypes}
                  />

                }

                </div>
                {
                  // Only for wahve
                  includes(this.state.affiliationTypes.value, 5)  &&
                      <div className='col'>
                        <TextField {...this.handleTextFieldUI('affiliationOther', 'Other')}  />
                      </div>
                }

                </div>
            <div className='row'>
              { this.props.labels.showIiabaState &&
                <div className='col grow-4'>
                <DropDownMenu
                  {...this.handleDropdownUI('iiabaState', 'State Association Memberships to IIABA')}
                  menuItems={this.iiabaStateMenuItems()}
                />
              </div>
            }
            </div>

        </div>

        <div className='grid company-billing'>
            <div className='row'>
                {
                  this.props.labels.showPlacementFee
                  &&
                  <div className='col grow-4'>
                    <DropDownMenu
                      {...this.handlePlacementFeeDropdownUI()}
                    />
                  </div>
                }
                <div className='col grow-4'>

                  <DropDownMenu
                    {...this.handleDropdownUI('referrer', 'Referrer')}
                    menuItems={[]}
                  />

                </div>
                <div className='col grow-4'>

                  {/* ToDo: White-labelling */}
                  <DropDownMenu
                    {...this.handleDropdownUI('salesPartner', 'Sales Partner')}
                    menuItems={this.salesPartnerMenuItems()}
                  />

                </div>
                <div className='col grow-4'>
                  <DropDownMenu
                    {...this.handleDropdownUI('commission', 'Commission')}
                    menuItems={map(this.props.staticData.commission, ({id, value}) => ({primaryText: `${(value * 100)}%`, value}))}
                  />
                </div>

            </div>

             <div className='row fixed-width-field'></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Worksheet/Content/Profile/index.js